export default function useLiveValue(baseValue) {
    return baseValue;
}
